import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";
import request from "@/lib/api/handler";
import {
  ICandidateObject,
  ICandidateStatus,
  IJobOpening,
} from "@/redux/features/candidateProfileSlice";

export interface CandidateOpportunityProfile {
  candidate: ICandidateObject;
  company: {
    name?: string;
  };
  jobOpening: IJobOpening;
  candidateStatus: ICandidateStatus;
}

export const useCandidateOpportunityProfileQuery = (candidateStatusId = "") => {
  const { isLoading, data, error } = useQuery({
    queryKey: QueryKeys.candidateOpportunityProfile(candidateStatusId),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: !!candidateStatusId,
    queryFn: async () => {
      return request<CandidateOpportunityProfile>({
        method: "GET",
        path: `/api/jobOpening/candidateStatus/${candidateStatusId}`,
      });
    },
  });

  return {
    candidateOpportunityProfileLoading: isLoading,
    candidateOpportunityProfile: data ?? null,
    candidateOpportunityProfileError: error ?? null,
  };
};
